import { STAGE_COUNTER_TIME } from '../../constants/timers';
import moment from 'moment';
import mtz from 'moment-timezone';

/**
 * utility function to compare input date-time with current date-time
 * @param date string Format: "1970-01-01 00:00:00"
 * @returns true when input date-time is expired
 */
export const isTimeExpired = (date: string): boolean => {
  return moment().isAfter(mtz.tz(date, 'Asia/Kolkata').clone().tz(moment.tz.guess()));
};

/**
 * @param date string Format: "1970-01-01 00:00:00"
 * @returns true just before 1 hour (STAGE_COUNTER_TIME) than the date passed
 */
export const showCounter = (date: string): boolean => {
  return (
    !isTimeExpired(date) &&
    moment().isAfter(mtz.tz(moment(date).subtract(STAGE_COUNTER_TIME), 'Asia/Kolkata').clone().tz(moment.tz.guess()))
  );
};
